<template>
  <v-container>
    <v-content>
      <div class="loader text-xs-center pt-5">
        <span>Logging in</span>
        <v-progress-circular indeterminate class="loadingCircle"/>
      </div>
    </v-content>
  </v-container>
</template>

<script>
  export default {};
</script>

<style lang="less">
  @import '../../style/variables.less';

  body {
    background-color: @edval-dark;
  }

  .loader {
    color: #ffffff;
    vertical-align: super;
    span {
      font-size: 1.5em;
    }

    .loadingCircle {
      margin-left: 40px;
      color: @edval-light;
    }
  }
</style>
